'use strict';exports.__esModule = true;var _PublishPropertyFormConstants = require('../containers/PublishForm/PublishPropertyFormConstants');

var paramsContain = function paramsContain(params, array) {return params.some(function (item) {return array.indexOf(item) >= 0;});};

var checkAdvancedFiltersQuantity = function checkAdvancedFiltersQuantity(params, withPrice) {
  var buildingCommoditiesValues = (0, _PublishPropertyFormConstants.commoditiesOptions)(function () {}).map(function (item) {return item.id;});
  var propertyCommoditiesValues = (0, _PublishPropertyFormConstants.additionsOptions)(function () {}).map(function (item) {return item.id;});
  var buildingCommodities = params.commodities ? paramsContain(params.commodities, buildingCommoditiesValues) : 0;
  var apartmentCommodities = params.commodities ? paramsContain(params.commodities, propertyCommoditiesValues) : 0;

  var floor = params.floor && (params.floor.min || params.floor.max);
  var notLastFloor = params.notLastFloor;
  var floorCount = floor || notLastFloor ? 1 : 0;

  var bathrooms = params.bathrooms && params.bathrooms.length && params.bathrooms[0] !== 'all' ? 1 : 0;
  var toilets = params.toilets && params.toilets.length && params.toilets[0] !== 'all' ? 1 : 0;
  var year = params.constructionYear && (params.constructionYear.min || params.constructionYear.max) ? 1 : 0;
  var area = params.area && (params.area.min || params.area.max) ? 1 : 0;

  var keys = ['balcony', 'elevator', 'parkingSpot', 'photos'];


  var price = withPrice && (params.price.minPrice || params.price.minPrice) ? 1 : 0;
  var valuesCount = keys.filter(function (key) {return (
      typeof params[key] === 'boolean' && params[key]);}).length;

  var num = valuesCount +
  buildingCommodities +
  apartmentCommodities +
  floorCount +
  bathrooms +
  toilets +
  year +
  area +
  price;
  return num;
};exports.default =


checkAdvancedFiltersQuantity;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/checkAdvancedFiltersQuantity.js
// module id = 579
// module chunks = 0